var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isEndLogin==false?'':'ispadding',attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('router-view',{staticClass:"container"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"addressaaa"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.htmlWord)}}),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("浙ICP备19022020号")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f9b49ac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 